import React from 'react';
import MakerCheckerPage from './maker-checker/MakerCheckerPage';

const PendingApprovalsPage: React.FC = () => {
  return <MakerCheckerPage />;
};

export default PendingApprovalsPage;
